import { FC, ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components'

const StyledAlert = styled.div<{ isDevice?: boolean; marginBottom?: string | number; marginLeft?: string | number }>`
  padding: 0.53rem 1rem;
  color: ${props => props.theme.colors.accent1};
  opacity: 1;
  transition: opacity 0.6s;
  background-color: ${props => props.theme.colors.secondary};
  font-size: 1rem;
  text-align: center;
  display: flex;
  align-items: center;
  font-weight: bold;
  border: 1px solid ${props => props.theme.colors.secondary};
  border-radius: 0.25rem;
  margin-bottom: ${props => props.marginBottom};
  margin-left:${props => props.marginLeft};
`

const StyledCloseBtn = styled.span`
  margin-left: 0.94rem;
  color: ${props => props.theme.colors.supplementary1};
  font-weight: bold;
  float: right;
  font-size: 1.56rem;
  line-height: 1.25rem;
  cursor: pointer;
  transition: 0.3s;

  &&:hover {
    color: ${props => props.theme.colors.supplementary1};
  }
`

type AlertProps = {
  children: ReactNode
  hideCloseButton?: boolean
  status?: boolean
  marginBottom?: string | number
  marginLeft?: string | number
}

export const Alert: FC<AlertProps> = ({ children, hideCloseButton, status, marginBottom, marginLeft }) => {
  const [showAlert, setShowAlert] = useState(true)
  const onClose = () => {
    setShowAlert(false)
  }

  useEffect(() => {
    setShowAlert(true)
  }, [status])

  if (!showAlert) return null

  return (
    <StyledAlert marginBottom={marginBottom} marginLeft={marginLeft}>
      {children}
      {!hideCloseButton && (
        <StyledCloseBtn className="closebtn" onClick={onClose} aria-hidden="true">
          ×
        </StyledCloseBtn>
      )}
    </StyledAlert>
  )
}
